import { render } from "./MyLeaveList.vue?vue&type=template&id=5b02992c"
import script from "./MyLeaveList.vue?vue&type=script&lang=js"
export * from "./MyLeaveList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__